(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (this.header.classList.contains('menu-open')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.header.classList.contains('menu-open')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (this.header.classList.contains('menu-open')) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (this.header.classList.contains('menu-open')) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(function () {

  // preloadCard receives a .qf-card-group element (contains card-wrapper + swatches)
  function preloadCard(group) {
    group.querySelectorAll('.card-swatch[data-swatch-image]').forEach(function (s) {
      [[s.dataset.swatchImage, s.dataset.swatchSrcset], [s.dataset.swatchImage2, s.dataset.swatchSrcset2]].forEach(function (pair) {
        if (!pair[0]) return;
        var link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = pair[0];
        if (pair[1]) link.setAttribute('imagesrcset', pair[1]);
        document.head.appendChild(link);
      });
    });
    group.querySelectorAll('.card-hover-video').forEach(function (v) { v.load(); });
  }

  function applyExpansion(section) {
    var expand = section.dataset.expandListings === 'true';
    if (typeof window.qfExpandListings !== 'undefined') {
      expand = !!window.qfExpandListings;
    }
    if (expand) {
      section.classList.add('is-expanded');
    } else {
      section.classList.remove('is-expanded');
    }
  }

  function initCollection() {
    document.querySelectorAll('.qf-collection-section').forEach(applyExpansion);

    document.querySelectorAll('.qf-collection-section .qf-card-group').forEach(function (group) {
      // Move hover videos into card__inner so position:absolute inset:0 fills the image
      var inner = group.querySelector('.card__inner');
      if (inner) {
        group.querySelectorAll('.card-hover-video').forEach(function (v) { inner.appendChild(v); });
      }

      // Move card-swatches inside the visible card__information (last one = outside card__inner)
      // so they always flow directly below the price regardless of grid row height.
      var sw = group.querySelector('.card-swatches');
      if (sw) {
        var infos = group.querySelectorAll('.card__information');
        var info = infos[infos.length - 1];
        if (info) info.appendChild(sw);
      }
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          preloadCard(entry.target);
        });
      }, { rootMargin: '300px' });
      document.querySelectorAll('.qf-collection-section .qf-card-group').forEach(function (group) {
        if (group.querySelector('.card-swatch[data-swatch-image], .card-hover-video')) io.observe(group);
      });
    }

    // Mark first swatch active, update card link, swap card image to match
    document.querySelectorAll('.qf-collection-section .qf-card-group').forEach(function (group) {
      var first = group.querySelector('.card-swatch');
      if (!first) return;
      first.classList.add('is-active');

      var cardLink = group.querySelector('[id^="CardLink-"]');
      if (cardLink) {
        cardLink.dataset.originalHref = cardLink.href;
        cardLink.href = first.href;
      }

      if (!first.dataset.swatchImage) return;
      var imgs = group.querySelectorAll('.card__media img.motion-reduce');
      if (!imgs[0]) return;

      imgs[0].dataset.originalSrc = imgs[0].src;
      imgs[0].dataset.originalSrcset = imgs[0].srcset || '';
      imgs[0].src = first.dataset.swatchImage;
      imgs[0].srcset = first.dataset.swatchSrcset || '';

      if (imgs[1] && first.dataset.swatchImage2) {
        imgs[1].dataset.originalSrc = imgs[1].src;
        imgs[1].dataset.originalSrcset = imgs[1].srcset || '';
        imgs[1].src = first.dataset.swatchImage2;
        imgs[1].srcset = first.dataset.swatchSrcset2 || '';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollection);
  } else {
    initCollection();
  }

  // _hovCard is the .card-wrapper (image boundary for hover detection)
  var _hovCard = null;
  var _rafPending = false;
  var _mx = 0, _my = 0;

  // Videos are moved into card__inner (inside card-wrapper) by init, so this works
  function _stopHoverVideo(cardWrapper) {
    cardWrapper.querySelectorAll('.card-hover-video').forEach(function (v) {
      if (!v.paused) { v.pause(); v.currentTime = 0; }
      v.style.display = 'none';
    });
  }

  function _updateSecondaryImg() {
    _rafPending = false;
    if (!_hovCard) return;
    var inner = _hovCard.querySelector('.card__inner');
    var imgs = _hovCard.querySelectorAll('.card__media img.motion-reduce');
    if (!imgs[0]) return;

    var inInner = false;
    if (inner) {
      var r = inner.getBoundingClientRect();
      inInner = _mx >= r.left && _mx <= r.right && _my >= r.top && _my <= r.bottom;
    }

    if (!inInner) {
      imgs[0].style.opacity = '';
      if (imgs[1]) { imgs[1].style.opacity = ''; imgs[1].style.transform = ''; }
      _stopHoverVideo(_hovCard);
      return;
    }

    // Swatches are siblings of card-wrapper inside qf-card-group
    var group = _hovCard.closest('.qf-card-group');
    var active = group && group.querySelector('.card-swatch.is-active');

    var videoId = active && active.dataset.swatchVideo;
    if (videoId) {
      var video = document.getElementById(videoId);
      if (video) {
        imgs[0].style.opacity = '0';
        if (imgs[1]) { imgs[1].style.opacity = ''; imgs[1].style.transform = ''; }
        video.style.display = 'block';
        if (video.paused) video.play().catch(function () {});
        return;
      }
    }

    _stopHoverVideo(_hovCard);
    var img2 = active && active.dataset.swatchImage2;
    if (!img2 || !imgs[1]) {
      imgs[0].style.opacity = '';
      if (imgs[1]) { imgs[1].style.opacity = ''; imgs[1].style.transform = ''; }
      return;
    }
    imgs[1].src = img2;
    imgs[1].srcset = active.dataset.swatchSrcset2 || '';
    imgs[0].style.opacity = '0';
    imgs[1].style.opacity = '1';
    imgs[1].style.transform = 'scale(1.03)';
  }

  document.addEventListener('mousemove', function (e) {
    _mx = e.clientX; _my = e.clientY;
    if (!_hovCard || _rafPending) return;
    _rafPending = true;
    requestAnimationFrame(_updateSecondaryImg);
  }, { passive: true });

  document.addEventListener('mouseover', function (e) {
    var cw = e.target.closest && e.target.closest('.qf-collection-section .card-wrapper');
    if (cw && _hovCard !== cw) _hovCard = cw;
  });

  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest && e.target.closest('.card-wrapper');
    if (!card || !card.closest('.qf-collection-section')) return;
    if (card.contains(e.relatedTarget)) return;
    var imgs = card.querySelectorAll('.card__media img.motion-reduce');
    if (imgs[0]) { imgs[0].style.opacity = ''; }
    if (imgs[1]) { imgs[1].style.opacity = ''; imgs[1].style.transform = ''; }
    _stopHoverVideo(card);
    if (_hovCard === card) _hovCard = null;
  });

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest && e.target.closest('.qf-collection-section .card-swatch');
    if (!swatch) return;
    if (swatch.classList.contains('is-active')) return;

    e.preventDefault();

    // Use qf-card-group as scope — swatch is a sibling of card-wrapper, not a child
    var group = swatch.closest('.qf-card-group');
    if (!group) return;

    group.querySelectorAll('.card-swatch.is-active').forEach(function (s) { s.classList.remove('is-active'); });
    swatch.classList.add('is-active');

    var cardLink = group.querySelector('[id^="CardLink-"]');
    if (cardLink) cardLink.href = swatch.href;

    var cardWrapper = group.querySelector('.card-wrapper');
    if (cardWrapper) _stopHoverVideo(cardWrapper);

    if (!swatch.dataset.swatchImage) return;

    var imgs = group.querySelectorAll('.card__media img.motion-reduce');
    if (!imgs[0]) return;

    if (!imgs[0].dataset.originalSrc) {
      imgs[0].dataset.originalSrc = imgs[0].src;
      imgs[0].dataset.originalSrcset = imgs[0].srcset;
    }
    imgs[0].src = swatch.dataset.swatchImage;
    imgs[0].srcset = swatch.dataset.swatchSrcset || '';

    if (imgs[1] && swatch.dataset.swatchImage2) {
      if (!imgs[1].dataset.originalSrc) {
        imgs[1].dataset.originalSrc = imgs[1].src;
        imgs[1].dataset.originalSrcset = imgs[1].srcset;
      }
      imgs[1].src = swatch.dataset.swatchImage2;
      imgs[1].srcset = swatch.dataset.swatchSrcset2 || '';
    }
  });

}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qf-featured-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Idempotency guard — if this script is ever included twice, the second run must not
  // re-bind the document-level listeners or re-run init (that would double every hover
  // play()/load() and was a suspected contributor to the video-fetch storm).
  if (window.__qfFeaturedProductsInit) return;
  window.__qfFeaturedProductsInit = true;

  // preloadCard receives a .qf-card-group (contains card-wrapper + swatches as siblings)
  // In adapt mode, update card__inner --ratio-percent to match the displayed image's actual ratio.
  // Prevents left/right cropping when swatch images have a different aspect ratio than featured_media.
  function adaptRatio(group, img) {
    if (!group || !img) return;
    if (group.dataset.imageRatio !== 'adapt') return;
    function apply() {
      if (!img.naturalWidth || !img.naturalHeight) return;
      var pct = (img.naturalHeight / img.naturalWidth * 100).toFixed(4) + '%';
      var inner = group.querySelector('.card__inner.ratio');
      if (inner) inner.style.setProperty('--ratio-percent', pct);
    }
    if (img.complete && img.naturalWidth) { apply(); }
    else { img.addEventListener('load', apply, { once: true }); }
  }

  var _isHoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function preloadCard(group) {
    // Preload swatch primary + hover images on all devices — swatch clicks work on mobile too.
    // Swatch hover images (data-swatch-image2) are hover-only so skip them on touch devices.
    group.querySelectorAll('.card-swatch[data-swatch-image]').forEach(function (s) {
      var pairs = _isHoverDevice
        ? [[s.dataset.swatchImage, s.dataset.swatchSrcset], [s.dataset.swatchImage2, s.dataset.swatchSrcset2]]
        : [[s.dataset.swatchImage, s.dataset.swatchSrcset]];
      pairs.forEach(function (pair) {
        if (!pair[0]) return;
        var link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = pair[0];
        if (pair[1]) link.setAttribute('imagesrcset', pair[1]);
        document.head.appendChild(link);
      });
    });
    // Hover videos are intentionally NOT loaded here. They keep preload="none" and are
    // fetched lazily on first hover via the concurrency-capped scheduler (_qfRequestPlay).
    // Eagerly calling .load()/prime on every color's video for every in-viewport card was
    // the source of the parallel multi-MB fetch storm that throttled the CDN into 503s.
  }

  function init() {
    document.querySelectorAll('.qf-featured-products .qf-card-group').forEach(function (group) {
      // Move hover videos into card__media — only needed on hover-capable devices.
      if (_isHoverDevice) {
        var media = group.querySelector('.card__media');
        if (media) {
          group.querySelectorAll('.card-hover-video').forEach(function (v) { media.appendChild(v); });
        }
      }

      // Move card-swatches inside the visible card__information (last one = outside card__inner)
      // so they always flow directly below the price regardless of grid row height.
      var sw = group.querySelector('.card-swatches');
      if (sw) {
        var infos = group.querySelectorAll('.card__information');
        var info = infos[infos.length - 1];
        if (info) info.appendChild(sw);
      }
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          preloadCard(entry.target);
        });
      }, { rootMargin: '200px' });
      document.querySelectorAll('.qf-featured-products .qf-card-group').forEach(function (group) {
        // Only swatch images are preloaded now; videos load on first hover, not on scroll-in.
        if (group.querySelector('.card-swatch[data-swatch-image]')) io.observe(group);
      });
    }

    // Mark first swatch active, point the card link at that variant, swap card image to match
    document.querySelectorAll('.qf-featured-products .qf-card-group').forEach(function (group) {
      var first = group.querySelector('.card-swatch');
      if (!first) return;
      first.classList.add('is-active');

      var cardLink = group.querySelector('[id^="CardLink-"]');
      if (cardLink) {
        cardLink.dataset.originalHref = cardLink.href;
        cardLink.href = first.href;
      }

      if (!first.dataset.swatchImage) return;
      var imgs = group.querySelectorAll('.card__media img.motion-reduce');
      if (!imgs[0]) return;

      imgs[0].dataset.originalSrc = imgs[0].src;
      imgs[0].dataset.originalSrcset = imgs[0].srcset || '';
      imgs[0].src = first.dataset.swatchImage;
      imgs[0].srcset = first.dataset.swatchSrcset || '';
      adaptRatio(group, imgs[0]);

      if (imgs[1] && first.dataset.swatchImage2) {
        imgs[1].dataset.originalSrc = imgs[1].src;
        imgs[1].dataset.originalSrcset = imgs[1].srcset || '';
        imgs[1].src = first.dataset.swatchImage2;
        imgs[1].srcset = first.dataset.swatchSrcset2 || '';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // --- Secondary image hover ---
  // card__heading a::after (position:absolute; inset:0) covers the entire card, so
  // mouseover on <a> fires for the whole card — including the text area below the image.
  // mouseover also won't re-fire when the cursor moves from image to text while staying
  // inside the same <a>. Solution: track the active card via mouseover on card-wrapper,
  // then use mousemove + rAF to check whether the cursor is inside card__inner on each
  // frame, and show/hide the secondary image accordingly.

  var _hovCard = null;
  var _rafPending = false;
  var _mx = 0, _my = 0;

  // --- Hover-video controller (one at a time) ---
  // Only ONE hover video is ever loading/playing across the whole grid. A new hover
  // preempts the current one — pausing it AND aborting its in-flight download — so the
  // active video gets the full network pipeline and starts smoothly (~0.3s on a fast
  // connection), instead of several multi-MB fetches competing and starving each other
  // (the behavior that produced AbortErrors / a 17s-open 0-byte request / CDN stalls).
  //
  // The <video> uses <source> children + preload="none". To truly abort a fetch we must
  // detach the sources and call load() (removeAttribute('src')+load() is a no-op while
  // <source> children remain). Sources are cached so we can re-attach on the next hover.
  var _qfActiveVideo = null;

  function _qfAttachSources(v) {
    if (!v._qfDetached) return;
    (v._qfSources || []).forEach(function (s) {
      var el = document.createElement('source');
      el.setAttribute('src', s.src);
      if (s.type) el.setAttribute('type', s.type);
      v.appendChild(el);
    });
    v.load();
    v._qfDetached = false;
  }

  function _qfDetachSources(v) {
    if (v._qfDetached) return;
    if (!v._qfSources) {
      v._qfSources = Array.prototype.map.call(v.querySelectorAll('source'), function (s) {
        return { src: s.getAttribute('src'), type: s.getAttribute('type') };
      });
    }
    while (v.firstChild) v.removeChild(v.firstChild);
    v.removeAttribute('src');
    v.load(); // no source present now → aborts any in-flight fetch and empties the element
    v._qfDetached = true;
  }

  function _qfHardStop(v) {
    if (v._qfDeferTimer) { clearTimeout(v._qfDeferTimer); v._qfDeferTimer = null; }
    v.classList.remove('is-playing');
    if (!v.paused) v.pause();
    _qfDetachSources(v);
    if (_qfActiveVideo === v) _qfActiveVideo = null;
  }

  function _qfRequestPlay(video, onReady) {
    // Quick re-hover of the same card: cancel a pending teardown and keep playing.
    if (video._qfDeferTimer) { clearTimeout(video._qfDeferTimer); video._qfDeferTimer = null; }
    if (_qfActiveVideo === video) {
      if (!video.paused) onReady();
      return;
    }
    // Preempt whatever is active so the new video owns the whole pipeline.
    if (_qfActiveVideo) _qfHardStop(_qfActiveVideo);
    _qfActiveVideo = video;
    _qfAttachSources(video);

    var token = { cancelled: false };
    if (video._qfToken) video._qfToken.cancelled = true;
    video._qfToken = token;
    // play() resolves once the first frame is presented — reveal then so the crossfade
    // never shows a blank frame (the poster covers the brief load window before that).
    video.play().then(function () {
      if (token.cancelled || _qfActiveVideo !== video) return;
      onReady();
    }).catch(function () {});
  }

  // Deferred teardown — tiny mouse jitter in/out of a card shouldn't thrash the download.
  // If the cursor returns within the window, _qfRequestPlay clears this timer.
  function _stopHoverVideo(card) {
    card.querySelectorAll('.card-hover-video').forEach(function (v) {
      if (v._qfToken) v._qfToken.cancelled = true;
      v.classList.remove('is-playing');
      if (v._qfDeferTimer) clearTimeout(v._qfDeferTimer);
      v._qfDeferTimer = setTimeout(function () {
        v._qfDeferTimer = null;
        if (!v.paused) v.pause();
        _qfDetachSources(v);
        if (_qfActiveVideo === v) _qfActiveVideo = null;
      }, 400);
    });
  }

  function _updateSecondaryImg() {
    _rafPending = false;
    if (!_hovCard) return;
    var inner = _hovCard.querySelector('.card__inner');
    var imgs = _hovCard.querySelectorAll('.card__media img.motion-reduce');
    if (!imgs[0]) return;

    var inInner = false;
    if (inner) {
      var r = inner.getBoundingClientRect();
      inInner = _mx >= r.left && _mx <= r.right && _my >= r.top && _my <= r.bottom;
    }

    if (!inInner) {
      imgs[0].style.opacity = '';
      if (imgs[1]) { imgs[1].style.opacity = ''; imgs[1].style.transform = ''; }
      _stopHoverVideo(_hovCard);
      return;
    }

    // Swatches are siblings of card-wrapper inside qf-card-group
    var group = _hovCard.closest('.qf-card-group');
    var active = group && group.querySelector('.card-swatch.is-active');

    // Video hover takes priority over image2
    var videoId = active && active.dataset.swatchVideo;
    if (videoId) {
      var video = document.getElementById(videoId);
      if (video) {
        if (imgs[1]) { imgs[1].style.opacity = ''; imgs[1].style.transform = ''; }
        var img0 = imgs[0];
        // One-at-a-time: loads on hover, preempts any other playing video, reveals once
        // this video's first frame is presented.
        _qfRequestPlay(video, function () {
          img0.style.opacity = '0';
          video.classList.add('is-playing');
        });
        return;
      }
    }

    // Fall back to static image2
    _stopHoverVideo(_hovCard);
    var img2 = active && active.dataset.swatchImage2;
    if (!img2 || !imgs[1]) {
      imgs[0].style.opacity = '';
      if (imgs[1]) { imgs[1].style.opacity = ''; imgs[1].style.transform = ''; }
      return;
    }
    imgs[1].src = img2;
    imgs[1].srcset = active.dataset.swatchSrcset2 || '';
    imgs[0].style.opacity = '0';
    imgs[1].style.opacity = '1';
    imgs[1].style.transform = 'scale(1.03)';
  }

  // Skip hover effects entirely on touch-primary devices — iOS fires synthetic mousemove
  // on tap, which would trigger video playback when the user intends to navigate.
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {

    document.addEventListener('mousemove', function (e) {
      _mx = e.clientX; _my = e.clientY;
      if (!_hovCard || _rafPending) return;
      _rafPending = true;
      requestAnimationFrame(_updateSecondaryImg);
    }, { passive: true });

    document.addEventListener('mouseover', function (e) {
      var cw = e.target.closest && e.target.closest('.qf-featured-products-section .card-wrapper');
      if (cw && _hovCard !== cw) _hovCard = cw;
    });

    document.addEventListener('mouseout', function (e) {
      var card = e.target.closest && e.target.closest('.card-wrapper');
      if (!card || !card.closest('.qf-featured-products-section')) return;
      if (card.contains(e.relatedTarget)) return;
      var imgs = card.querySelectorAll('.card__media img.motion-reduce');
      if (imgs[0]) { imgs[0].style.opacity = ''; }
      if (imgs[1]) { imgs[1].style.opacity = ''; imgs[1].style.transform = ''; }
      _stopHoverVideo(card);
      if (_hovCard === card) _hovCard = null;
    });

  }

  // --- Swatch click ---
  // First click: mark active, swap images, update card link.
  // Second click on same active swatch: follows href to navigate to that variant.
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest && e.target.closest('.card-swatch');
    if (!swatch) return;
    if (swatch.classList.contains('is-active')) return;

    e.preventDefault();

    // Use qf-card-group as scope — swatch is a sibling of card-wrapper, not a child
    var group = swatch.closest('.qf-card-group');
    if (!group) return;

    group.querySelectorAll('.card-swatch.is-active').forEach(function (s) { s.classList.remove('is-active'); });
    swatch.classList.add('is-active');

    var cardLink = group.querySelector('[id^="CardLink-"]');
    if (cardLink) cardLink.href = swatch.href;

    var cardWrapper = group.querySelector('.card-wrapper');
    if (cardWrapper) _stopHoverVideo(cardWrapper);

    if (!swatch.dataset.swatchImage) return;

    var imgs = group.querySelectorAll('.card__media img.motion-reduce');
    if (!imgs[0]) return;

    if (!imgs[0].dataset.originalSrc) {
      imgs[0].dataset.originalSrc = imgs[0].src;
      imgs[0].dataset.originalSrcset = imgs[0].srcset;
    }
    imgs[0].src = swatch.dataset.swatchImage;
    imgs[0].srcset = swatch.dataset.swatchSrcset || '';
    adaptRatio(group, imgs[0]);

    if (imgs[1] && swatch.dataset.swatchImage2) {
      if (!imgs[1].dataset.originalSrc) {
        imgs[1].dataset.originalSrc = imgs[1].src;
        imgs[1].dataset.originalSrcset = imgs[1].srcset;
      }
      imgs[1].src = swatch.dataset.swatchImage2;
      imgs[1].srcset = swatch.dataset.swatchSrcset2 || '';
    }
  });

}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qf-lp-hero-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRoot(root) {
    if (root.dataset.qf2Init) return;
    root.dataset.qf2Init = '1';

    // ── Gallery: thumbnail tap + swipe-to-advance on the main image
    var main = root.querySelector('[data-qf2-main] .qf2-main-img__el');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-qf2-thumb]'));
    var current = 0;

    function activateThumb(index, scrollIntoView) {
      if (!thumbs.length) return;
      if (index < 0) index = thumbs.length - 1;
      if (index >= thumbs.length) index = 0;
      current = index;
      var thumb = thumbs[index];
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (main) {
        var full = thumb.getAttribute('data-full');
        var srcset = thumb.getAttribute('data-full-srcset');
        var alt = thumb.getAttribute('data-alt');
        if (srcset) main.srcset = srcset;
        if (full) main.src = full;
        if (alt) main.alt = alt;
      }
      if (scrollIntoView && thumb.scrollIntoView) {
        thumb.scrollIntoView({ inline: 'nearest', block: 'nearest' });
      }
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { activateThumb(i, false); });
    });

    // Swipe left/right on the main image to advance (mobile). Horizontal-dominant
    // gestures only — vertical scrolls and taps are ignored so the page still scrolls.
    var mainWrap = root.querySelector('[data-qf2-main]');
    if (mainWrap && thumbs.length > 1) {
      var sx = 0, sy = 0, tracking = false;
      mainWrap.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { tracking = false; return; }
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
      }, { passive: true });
      mainWrap.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        activateThumb(dx < 0 ? current + 1 : current - 1, true);
      }, { passive: true });
    }

    // ── Stamped badge (real review rating/count) — init once it's loaded site-wide
    if (root.querySelector('.stamped-product-reviews-badge')) {
      var stampedTries = 0;
      (function initStamped() {
        if (window.StampedFn && typeof window.StampedFn.init === 'function') {
          window.StampedFn.init();
          if (typeof window.StampedFn.loadBadges === 'function') window.StampedFn.loadBadges();
        } else if (stampedTries++ < 20) {
          setTimeout(initStamped, 300);
        }
      })();
    }

    // ── Lock to a single color: select the locked value (so the buy box uses it), then hide that option
    var lockWrap = root.querySelector('[data-qf2-lock-option]');
    if (lockWrap) {
      var lockOpt = (lockWrap.getAttribute('data-qf2-lock-option') || '').trim().toLowerCase();
      var lockVal = (lockWrap.getAttribute('data-qf2-lock-value') || '').trim().toLowerCase();
      var groups = lockWrap.querySelectorAll('.product-form__input');
      groups.forEach(function (fs) {
        var legend = fs.querySelector('legend, label');
        var name = legend ? legend.textContent.replace(':', '').trim().toLowerCase() : '';
        if (!lockOpt || name.indexOf(lockOpt) !== 0) return;
        if (lockVal) {
          // Only act if the locked value isn't already selected (guards against
          // re-firing a Combined Listing product swap when we're already on it).
          fs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
            if ((inp.value || '').trim().toLowerCase() === lockVal && !inp.checked) {
              inp.checked = true;
              inp.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }
        fs.style.display = 'none';
      });
    }

    // ── Real-inventory urgency for the selected variant
    var urgencyEl = root.querySelector('[data-qf2-urgency]');
    var invScript = root.querySelector('script[data-qf2-inventory]');
    var info = root.querySelector('.product__info-container');
    if (urgencyEl && invScript && info) {
      var inventory = {};
      try { inventory = JSON.parse(invScript.textContent); } catch (e) { inventory = {}; }
      var threshold = parseInt(urgencyEl.getAttribute('data-threshold'), 10);
      if (isNaN(threshold)) threshold = 5;
      var template = urgencyEl.getAttribute('data-template') || 'Only [qty] left in [size] — moving fast';

      function currentVariantId() {
        var input = info.querySelector('input[name="id"], select[name="id"]');
        return input ? input.value : null;
      }
      function updateUrgency() {
        var id = currentVariantId();
        var data = id ? inventory[id] : null;
        if (!data || typeof data.q !== 'number' || data.a !== true || data.q <= 0 || data.q > threshold) {
          urgencyEl.hidden = true;
          return;
        }
        urgencyEl.textContent = template
          .replace('[qty]', data.q)
          .replace('[size]', data.s != null ? data.s : '');
        urgencyEl.hidden = false;
      }
      updateUrgency();
      // product-info.js re-renders the info container on every variant change.
      var mo = new MutationObserver(function () { updateUrgency(); });
      mo.observe(info, { childList: true, subtree: true });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.qf-lp-hero-v2').forEach(initRoot);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qf-press-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTrack(track) {
    var set = track.querySelector('.qf-press-bar__set');
    if (!set) return;
    var setW = set.offsetWidth;
    if (!setW) return;

    // Clone the original set (browser reuses cached images — no extra downloads)
    // until the track covers viewport + one set width, preventing end-of-track blank space
    var existing = track.querySelectorAll('.qf-press-bar__set').length;
    var needed = Math.ceil((window.innerWidth + setW) / setW) + 1;
    for (var i = existing; i < needed; i++) {
      track.appendChild(set.cloneNode(true));
    }

    // Pixel-exact shift = one set width, overrides the -50% CSS fallback
    track.style.setProperty('--qf-marquee-shift', '-' + setW + 'px');
  }

  function init() {
    document.querySelectorAll('.qf-press-bar__track').forEach(initTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qf-video-editorial"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.qf-video-editorial__poster').forEach(function (btn) {
  btn.addEventListener('click', function () {
    btn.style.display = 'none';
  });
});

// When any <video> on the page starts playing, pause all others (hero video is exempt)
document.addEventListener('play', function (e) {
  if (e.target.tagName !== 'VIDEO') return;
  document.querySelectorAll('video:not(.qf-hero-video__video)').forEach(function (v) {
    if (v !== e.target) v.pause();
  });
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qf-wholesale-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('.qf-wholesale-contact');
  if (!section) return;

  // ── Zoho form iframe auto-resize ─────────────────────────
  var iframe = section.querySelector('iframe[src*="zohopublic.com"]');
  if (iframe) {
    window.addEventListener('message', function (event) {
      if (typeof event.data !== 'string') return;
      var parts = event.data.split('|');
      if (parts.length < 2) return;
      var height = parseInt(parts[1], 10);
      if (isNaN(height) || height <= 0) return;
      var newHeight = (height + 15) + 'px';
      if (iframe.style.height !== newHeight) iframe.style.height = newHeight;
    });
  }

  // ── Replace broken Zoho close icon with a styled button ──
  var closeImg = section.querySelector('img.calBookingCloseIcn');
  if (closeImg) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Close');
    btn.innerHTML = '×';
    btn.className = 'qf-cal-close-btn';
    // Preserve inline positioning (left, top, z-index)
    btn.style.left = closeImg.style.left || 'calc(80%)';
    btn.style.top  = closeImg.style.top  || '100px';
    // Copy the onclick (inline attribute compiles to .onclick property)
    btn.onclick = closeImg.onclick;
    closeImg.parentNode.replaceChild(btn, closeImg);
  }
}());

  } catch(e) { console.error(e); }
})();
})();
